import { styled } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { JonumLimitsSection } from '@sorare/core/src/components/jonum/JonumLimitsSection';
import { LegalWarningBanner } from '@sorare/core/src/components/jonum/LegalWarningBanner';
import { ActivityReports } from '@sorare/core/src/components/settings/ActivityReports';
import { DeleteAccount } from '@sorare/core/src/components/settings/DeleteAccount';
import { MyReferrer } from '@sorare/core/src/components/settings/MyReferrer';
import { PersonalInfo } from '@sorare/core/src/components/settings/PersonalInfo';
import { SocialAccounts } from '@sorare/core/src/components/settings/SocialAccounts';
import { UpdateProfile } from '@sorare/core/src/components/settings/UpdateProfile';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';
import { useApplyJonumRestriction } from '@sorare/core/src/hooks/useApplyJonumRestriction';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { DepositCard } from '@sorare/marketplace/src/components/settings/DepositCard';

import { SettingsWrapper } from '#src/components/settings/SettingsWrapper/index.tsx';

const LegalWarningBannerStyled = styled(LegalWarningBanner)`
  border-radius: var(--unit);
  background: var(--c-nd-100-opaque);
  padding: var(--unit);
`;

export const MyAccount = () => {
  const {
    flags: { jonumUserInfoCollection = false },
  } = useFeatureFlags();
  const showLegalWarning = useApplyJonumRestriction();

  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.MY_ACCOUNT]}>
      <Vertical gap={2}>
        <UpdateProfile withinSettings />
        <PersonalInfo />
        <JonumLimitsSection />
        <SocialAccounts />
        <MyReferrer />
        <DepositCard />
        <ActivityReports />
        <DeleteAccount />
        {jonumUserInfoCollection && showLegalWarning ? (
          <LegalWarningBannerStyled visibleOn="all" />
        ) : null}
      </Vertical>
    </SettingsWrapper>
  );
};

export default MyAccount;
